<template>
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 22.207c5.633 0 10.2-4.567 10.2-10.2 0-5.633-4.567-10.2-10.2-10.2-5.633 0-10.2 4.567-10.2 10.2 0 5.633 4.567 10.2 10.2 10.2Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="m5.653 19.986.907-4.579h.979a1.342 1.342 0 0 0 1.07-.526 1.306 1.306 0 0 0 .245-1.16L8.174 11a1.35 1.35 0 0 0-1.315-1.034H2.026M20.16 5.887h-3.699a1.35 1.35 0 0 0-1.314 1.034l-.68 2.72a1.306 1.306 0 0 0 .254 1.16 1.342 1.342 0 0 0 1.07.526h1.432l.707 4.307a1.36 1.36 0 0 0 1.324 1.133h1.813"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
